/**
 * 存储弹框的集合
 */
const allModalsMap = new Map()

/**
 * 添加弹框el到集合allModalsMap
 * @param {*HTMLElement} el 弹框的唯一标识，v-drag指令绑定的元素
 * @param {*Object} binding v-drag指令传递过来的参数
 */
function addElToMap(el, binding) {
  const parent = binding.value.root || document.body
  let dialogHeaderEl = ''
  let dragDom = ''
  if (binding.value.wrapClassName) {
    dialogHeaderEl = parent.querySelector(`.${binding.value.wrapClassName} .ant-modal-header`)
    dragDom = parent.querySelector(`.${binding.value.wrapClassName} .ant-modal`)
  } else {
    dialogHeaderEl = parent.querySelector('.ant-modal-header')
    dragDom = parent.querySelector('.ant-modal')
  }
  const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
  const originLeft = sty.left
  const originTop = sty.top
  if (!allModalsMap.get(el)) {
    allModalsMap.set(el, { dialogHeaderEl, dragDom, sty, originLeft, originTop })
  }
}

/**
 * 弹窗拖动方法
 * @param {*} el
 * @param {*} binding
 * @param {*} vnode
 * @param {*} oldVnode
 */
function handleModalDrag(el, binding) {
  addElToMap(el, binding)
  const { dialogHeaderEl, dragDom, sty } = allModalsMap.get(el)

  dialogHeaderEl.style.cursor = 'move'
  dialogHeaderEl.onmousedown = (e) => {
    // 鼠标按下，计算当前元素距离可视区的距离
    const disX = e.clientX - dialogHeaderEl.offsetLeft
    const disY = e.clientY - dialogHeaderEl.offsetTop

    // 获取到的值带px 正则匹配替换
    let styL, styT

    // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
    if (sty.left.includes('%')) {
      styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
      styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
    } else {
      styL = +sty.left.replace(/\px/g, '')
      styT = +sty.top.replace(/\px/g, '')
    }

    document.onmousemove = function (e) {
      // 通过事件委托，计算移动的距离
      const l = e.clientX - disX
      const t = e.clientY - disY

      // 移动当前元素
      dragDom.style.left = `${l + styL}px`
      dragDom.style.top = `${t + styT}px`
    }

    document.onmouseup = function (e) {
      document.onmousemove = null
      document.onmouseup = null
    }
  }
}
export default {
  install(app) {
    app.directive('drag', {
      mounted(el) {
        allModalsMap.set(el, null)
      },
      updated(el, binding) {
        // 弹框打开时执行下面代码
        if (binding.value.visible) {
          // 该弹窗已存在，打开时初始化起始位置
          if (allModalsMap.get(el)) {
            const { dragDom, originLeft, originTop } = allModalsMap.get(el)
            if (originTop) {
              dragDom.style.left = originLeft
              dragDom.style.top = originTop
            }
          } else {
            // 该弹窗不存在，为该弹框添加拖拽效果
            handleModalDrag(el, binding)
          }
        }
      },
      beforeUnmount(el) {
        // v-drag指令绑定的页面卸载时，从集合中删除对应的弹框
        allModalsMap.delete(el)
      }
    })
  }
}
